import styled from 'styled-components';
import { palette, font } from 'styled-theme';

const DashAppHolder = styled.div`
  font-family: ${font('primary', 0)};

  :where(h1, h2, h3, h4, h5, h6, a, p, input, li, textarea, span, div, img, svg) {
    font-family: Helvetica;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  a,
  p,
  input,
  li,
  textarea,
  span,
  div,
  img,
  svg {
    &::selection {
      background: ${palette('primary', 0)};
      color: #fff;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  a,
  p,
  input,
  textarea {
    color: ${palette('grayscale', 0)};
  }

  .ant-row {
    ${
      '' /* margin-left: -8px;
    margin-right: -8px; */
    };
  }

  .ant-row .ant-legacy-form-item {
    margin-bottom: 12px;
  }

  .ant-row > div {
    padding: 0;
  }

  .isoLeftRightComponent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .isoCenterComponent {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;

export default DashAppHolder;
